import { observable, reaction } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import TabMenuStore from './components/tab-menu/store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import BaseStore from '@src/utils/store/base-store';
import { jumpPage, aLink } from '@src/utils/common-util';
import { useEffect } from 'react';
import { useMount } from 'ahooks';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const language = getLanguageByPath();
class thirdPageStore extends BaseStore {
  imgSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      loop: true,
      loopAdditionalSlides: 1
    }
  });

  @observable tabsMap = {};

  @observable newsData = [];

  @observable tab_key = 'new';

  @observable
  layerData = {
    article_section: {},
    article_swipers: []
  };

  @observable
  localData = {
    more_buttom_btn: require(`./images/${language}/more-btn.png`),
    page_title: require(`./images/${language}/title.png`)
  };

  viewDetail = item => {
    if (item.url) {
      aLink(item.url);
      return;
    }
    // IS_DEV_ENV  DEPLOY_ENV
    if (!IS_DEV_ENV) {
      const url = 'news-detail.html';
      jumpPage(url, `#/?contentId=${item.contentId}`, true);
    } else {
      this?.redirect(`/news-detail?contentId=${item.contentId}`);
    }
  };

  more() {
    if (!IS_DEV_ENV) {
      const url = 'news-list.html';
      jumpPage(url, '#/');
    } else {
      this?.redirect('/news-list');
    }
  }

  tabMenuStore = new TabMenuStore({
    onTabChange: (index, item) => {
      this.tab_key = item.tab_key;
    }
  });

  use() {
    super.use();

    const funlinkData = useLayerData('part3');
    useEffect(
      () => {
        if (funlinkData) {
          const { article_tabs = [], article_section = {}, article_swipers = [] } = funlinkData;
          this.layerData = { article_section, article_swipers };
          this.tabMenuStore.tabList = article_tabs.map(tab => {
            this.tabsMap[tab.tab_key] = tab;
            return tab;
          });
        }
      },
      [funlinkData]
    );

    useMount(() => {
      reaction(
        () => [this.tab_key, this?.layerData?.article_section],
        () => {
          this.newsData = (this?.layerData?.article_section?.[this.tab_key] || []).sort((a, b) => b.publishedAt - a.publishedAt).slice(0, 5);
        },
        {
          fireImmediately: true
        }
      );
    });
  }
}
export default thirdPageStore;
